import get from 'lodash/get'
import { Block, PrensaEngine, Typography } from '@xprog/prensa'
import Link from 'next/link'
import React from 'react'
import { PrensaEngineCSSProp } from '@xprog/prensa/types'

import Icon from 'components/Icon/Icon.index'
import { useIcon } from 'hooks/useIcon'
import { useRouter } from 'next/router'

export type SectionTitleProps = {
  isExpanded?: boolean
  isReadMore?: boolean
  isSeeMore?: boolean
  isVideoBox?: boolean
  leftIcon?: boolean
  rightIcon?: boolean
  rightClick?: any
  readMoreLabel?: string
  titleColor?: string
  titleTarget?: boolean
  titleLink?: string
  titleLabel: string
  titleIcon?: string
}

const LinkStyled = PrensaEngine.styled('span', {
  align: ['row', 'left', 'middle'],
  cursor: 'pointer',
  width: 'fit-content'
})

const SectionTitle: React.FC<SectionTitleProps> = ({
  isExpanded,
  isReadMore,
  isSeeMore,
  isVideoBox,
  leftIcon = true,
  rightClick,
  rightIcon = true,
  readMoreLabel = 'Ver mais',
  titleColor,
  titleTarget,
  titleLink,
  titleLabel,
  titleIcon
}) => {

  const router = useRouter()
  const responsiveClass: Array<string> = []

  const LinkWrap: React.FC<any> = ({ children }) => {
    if (!titleLink || titleLink == '') return children
    const props = titleTarget ? { target: '_blank ' } : {}
    return (
      <Link {...props} href={titleLink}>
        <LinkStyled>{children}</LinkStyled>
      </Link>
    )
  }
  let iconSetaSeeMore = false
  let styleColummLeft: PrensaEngineCSSProp = {
    align: ['row', 'left', 'middle']
  }
  let styleColummRight = styleColummLeft
  let styleTitle: PrensaEngineCSSProp = {
    color: `$${titleColor}`,
    fontSize: '18px',
    lineHeight: '25px',
    letterSpacing: '0.4px',
    fontWeight: '500',
    m: '$0'
  }
  let styleExpanded: PrensaEngineCSSProp = {}
  if (isExpanded && !isVideoBox && !isSeeMore) {
    styleExpanded = {
      borderTopWidth: '1px',
      borderTopColor: '#e6e6e6',
      borderTopStyle: 'solid',
      paddingTop: '$3'
    }
  }
  if (isSeeMore) {
    leftIcon = false
    iconSetaSeeMore = true
    styleExpanded = {
      color: '#000000',
      pt: '$0',
      mb: '$8'
    }
    styleTitle = {
      ...styleTitle,
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400
    }
  }
  if (isVideoBox) {
    leftIcon = false
    titleIcon = 'IcEsporte'
    styleExpanded = {
      color: '#e6e6e6',
      pt: '$1',
      mb: '$8'
    }
    styleColummLeft = {
      ...styleColummLeft,
      position: 'relative',
      'p::before': {
        content: '_',
        backgroundColor: '#F06C6C',
        color: '#F06C6C',
        position: 'absolute',
        fontSize: '6px',
        lineHeight: '6px',
        left: '0px',
        top: '-20px',
        width: '72px'
      }
    }
    styleTitle = {
      ...styleTitle,
      fontSize: '25px',
      letterSpacing: '0.2px'
    }
    rightClick = () => router.push('/videos')
  }

  if(!titleIcon) {
    leftIcon = false
    if(titleLabel === 'Leia também') {
      styleTitle = {
        ...styleTitle,
        fontSize: '14px',
        fontWeight: 'bold',
        letterSpacing: '0.4px',
        lineHeight: '21px',
        textTransform: 'uppercase'
      }
    }
  }

  const setaName = titleIcon ? titleIcon.replace('Ic', 'IcSeta') : ''
  const iconSeta = {
    ...useIcon(titleIcon ? setaName : !setaName ? 'IcSetaEspecial' : '')
  }
  const titleIconData = useIcon(titleIcon || '')

  const styleReadMore: PrensaEngineCSSProp = {
    align: ['row', 'between', 'middle']
  }

  const departmentPath = get(window, 'location.pathname', '/')
  const isSeeMoreVisible = departmentPath !== titleLink
  return (
    <Block
      className={`Item ${responsiveClass.join(' ')}`}
      css={{
        align: ['row', 'left', 'bottom'],
        mb: '$4',
        width: '100%',
        ...styleExpanded,
        ...styleReadMore
      }}
    >
      <Block css={styleColummLeft}>
        <LinkWrap>
          {titleIcon && leftIcon && <Icon {...titleIconData} />}
          <Typography
            as='h3'
            css={{
              ...styleTitle,
              ml: leftIcon ? '$2' : '$0',
              mr: iconSetaSeeMore ? '$2' : '$0'
            }}
            variant='sectionTitle-default'
          >
            {titleLabel}
          </Typography>
          {iconSetaSeeMore && <Icon {...titleIconData} />}
        </LinkWrap>
      </Block>
      {isExpanded && isReadMore && isSeeMoreVisible && (
        <Block css={styleColummRight} onClick={rightClick}>
          <LinkWrap>
            <Typography
              css={{
                color: `$${titleColor}`,
                cursor: 'pointer',
                fontSize: '18px',
                lineHeight: '25px',
                letterSpacing: '0.4px',
                fontWeight: '500',
                m: '$0',
                mr: '$2',
                pt: '$0'
              }}
              variant='sectionTitle-default'
            >
              {readMoreLabel}
            </Typography>
            {iconSeta && rightIcon && <Icon {...iconSeta} />}
          </LinkWrap>
        </Block>
      )}
    </Block>
  )
}

SectionTitle.defaultProps = {
  titleColor: 'primary'
}

export default SectionTitle
